import { enumLockStatus } from "../constants";

export function ConvertToLockFlag(contentLocked, positionLocked) {
  var lockStatus;
  if (contentLocked) {
    if (positionLocked) lockStatus = enumLockStatus.contentPosLocked;
    else lockStatus = enumLockStatus.contentLocked;
  } else {
    if (positionLocked) lockStatus = enumLockStatus.positionLocked;
    else lockStatus = enumLockStatus.notLocked;
  }

  return lockStatus;
}
